import React, { lazy, Suspense } from 'react';

import { type RouteComponentProps } from 'react-router-dom';

type AgentEmbedProps = { agentId: string };

const AgentEmbedSuspense = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_async-standalone-directory_agent-embed-page" */ './main'
		),
);

const LazyAgentEmbed = (props: AgentEmbedProps): React.ReactElement => (
	<Suspense fallback={null}>
		<AgentEmbedSuspense {...props} />
	</Suspense>
);

const AgentEmbedRoute = ({
	match,
}: Pick<RouteComponentProps<{ agentId: string }>, 'match'>): React.JSX.Element => {
	return <LazyAgentEmbed agentId={match.params.agentId} />;
};

export default AgentEmbedRoute;
